import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
  useNavigate,
} from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";
import AdminDashboard from "./pages/Dashboard/AdminDashboard";
import LoginPage from "./pages/LoginPage";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import ApiButton from "./components/customComponent/ApiButton";
import DataTable from "./components/customComponent/DataTable";
import OperatorPage from "./components/CustomTable/OperatorPage";
import Sidebar from "./layouts/core/Sidebar"; // Import Sidebar component
import Analytics from "./components/customChart/Analatics";
import CsrReport from "./components/CustomTable/csrReport";
import TableStatic from "./components/CustomTable/TableStatic";
import Settings from "./components/CustomTable/Settings";
import useAutoLogout from "./hooks/useAutoLogout";
import { useDispatch } from "react-redux";
import { logout } from "./redux/slices/authSlice";
import { useEffect } from "react";

import { Box, Button } from "@mui/material"; // MUI components

// Helper function to check authentication status
const getAuthStatus = () => {
  const user = JSON.parse(localStorage.getItem("examDetails"));
  return user ? { isAuthenticated: true } : { isAuthenticated: false };
};

// Protected Route to ensure authentication
const ProtectedRoute = ({ children }) => {
  const auth = getAuthStatus();
  const dispatch = useDispatch();
  const navigate = useNavigate();

    const handleLogout = () => {
    dispatch(logout());
    localStorage.clear();
    navigate("/login");

  };
  useAutoLogout(handleLogout);
  // console.log("isAuthenticated", auth.isAuthenticated);
  return auth.isAuthenticated ? children : <Navigate to="/login" />;
};

const App = ({ toggleTheme, mode }) => {
  // State to control sidebar visibility
  const [isSidebarOpen, setSidebarOpen] = useState(true); // Set initial state to true so sidebar is open by default

  const toggleSidebar = () => {
    setSidebarOpen((prevState) => !prevState); // Toggle the sidebar open/close state
  };

  const [analytics, setAnalytics] = useState(false);
  function handleAnalytics(_) {
      setAnalytics(_);
  }
  // In your App.js file

return (
  <Router>
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="login" element={<LoginPage />} />

      {/* Protected routes */}
      <Route
        path="dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout handleAnalytics={handleAnalytics} />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard analytics={analytics} />} />
        <Route
          path="dashboard"
          element={<AdminDashboard analytics={analytics} />}
        />
        <Route path="operators" element={<OperatorPage />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="CsrReport" element={<CsrReport />} />
        <Route path="TableStatic" element={<TableStatic />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      
      <Route path="Api" element={<ApiButton />} />
      <Route path="/data-table" element={<DataTable />} />
    </Routes>
  </Router>
);
};

export default App;
